import { Box, TextField, Typography } from "@mui/material";
import { FieldProps } from "../../renderFieldInput";
import { extractTextAndTruncate } from "../../../../utils/textUtils";

type EvaluationsContentInputFieldProps = FieldProps;

export const EvaluationsContentInputField = ({ field, value }: EvaluationsContentInputFieldProps) => {
    const label = field.headerName || field.field;
    const content = value?.[field.field] || "";
    const preview = extractTextAndTruncate(content, 80);

    return (
        <Box>
            <TextField
                label={label}
                value={preview}
                disabled
                fullWidth
            />
            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                {label} deve ser preenchido no seu próprio modo de edição
            </Typography>
        </Box>
    );
};
